module.exports = "/_next/static/images/7bed29d9c6be69e3fd99d4ce47f166b1-dst.png";